var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7235 24.2784C14.3268 24.4184 13.6735 24.4184 13.2768 24.2784C9.8935 23.1234 2.3335 18.305 2.3335 10.1384C2.3335 6.53337 5.2385 3.6167 8.82016 3.6167C10.9435 3.6167 12.8218 4.64337 14.0002 6.23003C15.1785 4.64337 17.0685 3.6167 19.1802 3.6167C22.7618 3.6167 25.6668 6.53337 25.6668 10.1384C25.6668 18.305 18.1068 23.1234 14.7235 24.2784Z",
    fill: "#FF0000",
    stroke: "#FF0000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.91c7eac89bf847f8c9b9fd494b5b6c16.svg";
export { ForwardRef as ReactComponent };